import axios from "axios"

const ComptoirService = {}

ComptoirService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/comptoir/ajouter`, formData ,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}
export default ComptoirService ;